<template>
    <div class="q-echart">
      <div class="topContent">
        <div class="title">Revenue Daily Trend</div>
        <div class="rightContent">
          <div class="legend">
            <span class="legend1">Target</span>
            <span class="legend2">Actual</span>
          </div>
          <!-- <div class="chartSelect">
            <el-select @change="getValue" :disabled="loading" v-model="curVal" placeholder="请选择">
              <el-option
                class="revenue-labour-option"
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div> -->
        </div>
      </div>
      <div class="wrap">
        <div class="chartsContent">
          <ECharts ref="lineChart" :option="lineOptions" class="lineChart"></ECharts>
          <!-- <div class="x-axis clear">
            <div class="axis-number">00:00</div>
            <div class="axis-number">03:00</div>
            <div class="axis-number">06:00</div>
            <div class="axis-number">09:00</div>
            <div class="axis-number">12:00</div>
            <div class="axis-number">15:00</div>
            <div class="axis-number">18:00</div>
            <div class="axis-number">21:00</div>
            <div class="axis-number">24:00</div>
          </div> -->
        </div>
      </div>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import ECharts from 'vue-echarts';
  import 'echarts';
  export default {
    name: 'Home',
    props: {
      weekDay: {
        type: Number,
        default: null,
      },
      loading: {
        type: Boolean,
        default: true
      },
      timeZone: {
        default: null
      },
      datum: {
        type: Object,
        default: {}
      },
      showDeputyCycle: {
        type: Boolean,
        default: false
      },
      weekStart: {
        type: Number,
        default: false
      },
      dailyTrendDay: null,
      currentDay: null,
      isThisWeek: false,
    },
    components: {ECharts},
    data(){
      return {
        curVal:"revenue",//下拉选择初始值
        options:[//下拉选择数据
          {value: 'revenue',label: 'Revenue'},
          {value: 'labour',label: 'Labour'}
        ],
        curDay:(new Date()).getDay(),//当前选中的日期
        weekDays:[],
        lineOptions:{
          color: ["#ffffff","#2FCBFF"],//颜色配置
          tooltip: {//鼠标经过的提示
            backgroundColor: '#EA3796',
            borderColor: '#EA3796',
            trigger: 'axis',
            textStyle: {
              color: 'white',
              'fontFamily': 'PingFang SC-Regular, PingFang SC'
            },
            axisPointer: {type: 'line'},
            valueFormatter:value => {
              let num = parseFloat(value),
                valueText = (num.toString().indexOf ('.') !== -1) ?
                num.toLocaleString():num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
              return value !== null && value !== undefined ? `$${valueText}` : '-';
            }
          },
          grid: {
            top: '5%',
            left: '4%',
            right: '3%',
            bottom: '8%'
          },
          legend: {//图例
            show:false,
            right: 30,
            icon:'circle',
            position:'right',
            data: ['Target', 'Actual',],
          },
          xAxis: [{//x轴
            type: 'category',
            boundaryGap: false,
            axisTick: {
              show:true, //隐藏x轴刻度
              alignWithLabel: true
            },
            axisLabel:{
              fontFamily: 'PingFang SC-Medium',
              color: '#657291',//设置刻度数值颜色
              margin: 13,//设置数值跟轴的间距
            },
            //data: ["00:00","01:00","02:00","03:00","04:00","05:00","06:00","07:00","08:00","09:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00","18:00","19:00","20:00","21:00","22:00","23:00","24:00"]
            // data: ["00:00","03:00","06:00","09:00","12:00","15:00","18:00","21:00","24:00"]
            // data: [
            // "00:00","00:15","00:30","00:45","01:00","01:15","01:30","01:45","02:00","02:15","02:30","02:45",
            // "03:00","03:15","03:30","03:45","04:00","04:15","04:30","04:45","05:00","05:15","05:30","05:45",
            // "06:00","06:15","06:30","06:45","07:00","07:15","07:30","07:45","08:00","08:15","08:30","08:45",
            // "09:00","09:15","09:30","09:45","10:00","10:15","10:30","10:45","11:00","11:15","11:30","11:45",
            // "12:00","12:15","12:30","12:45","13:00","13:15","13:30","13:45","14:00","14:15","14:30","14:45",
            // "15:00","15:15","15:30","15:45","16:00","16:15","16:30","16:45","17:00","17:15","17:30","17:45",
            // "18:00","18:15","18:30","18:45","19:00","19:15","19:30","19:45","20:00","20:15","20:30","20:45",
            // "21:00","21:15","21:30","21:45","22:00","22:15","22:30","22:45","23:00","23:15","23:30","23:45","24:00"]
          }],
          yAxis: [{//y轴
              type: 'value',
              axisLine: {show: false,},
              splitLine :{
                lineStyle:{
                  opacity:0.1
                },
                show: true 
              },
              axisLabel:{
                color: '#657291',//设置刻度数值颜色
                fontFamily: 'PingFang SC-Medium',
                formatter(val){//设置y轴刻度展示形式
                  return val > 1000?val/1000+'k': val;
                }
              }
          }],
          series: [//数据格式
            {
              name: 'Target',
              type: 'line',
              data: [],
              smooth: true,
              showSymbol: false,
            },
            {
              name: 'Actual',
              type: 'line',
              data: [],
              smooth: true,
              showSymbol: false,
            }
          ],
          
          isPastMidnight: false,
      },
      }
    },
    mounted() {
      window.addEventListener("resize",()=>{//监听窗口改变调节图表
        if(this.$refs.lineChart){
          this.$refs.lineChart.resize();
        }
      });
      this.initFn();
  
      if (this.weekDay && this.weekDay >= 0) {
          this.curDay = this.weekDay;
      }
  
      this.$root.$on('show-revenue-graph', () => {
        this.curVal = 'revenue'
        console.log(this.curVal, this.curVal, this.curDay);
        this.$emit('evtFromChart', 'echart', this.curVal, this.curDay)
      })
    },
    methods: {
      getValue(e) {
        this.$emit('evtFromChart', 'echart', e, this.curDay)
      },
      initFn(arr){//初始事件
        const order = !this.showDeputyCycle
        const weekStart = this.weekStart
        const dates = [
          {code:1,title:"Mon",isDisable:false},
          {code:2,title:"Tue",isDisable:false},
          {code:3,title:"Wed",isDisable:false},
          {code:4,title:"Thu",isDisable:false},
          {code:5,title:"Fri",isDisable:false},
          {code:6,title:"Sat",isDisable:false},
          {code:7,title:"Sun",isDisable:false}
        ];
        const nowDay = new Date(),curDay = nowDay.getDay() === 0 ? 7 : nowDay.getDay();//获取当天是周几
        let weekDays = [];
        //["Mon","Tue","Wed","Thu","Fri","Sat","Sun"]
        if(order){//正序
          weekDays = dates;
          const dayIndex = weekDays.findIndex(item =>item.code === curDay);//获取本周已到跟未到的日期分割索引
          weekDays.forEach((item,index) => {
            if(index<=dayIndex){
              item.isDisable = false;
            }else{
              item.isDisable = true;
            }
          })
        }else{//乱序
          const num = dates.findIndex(item =>item.code === weekStart);//获取分割上周本周的索引
          const newDays1 = dates.filter((item,index) => index>=num);//上周数据
          const newDays2 = dates.filter((item,index) => index<num);//本周数据
          const dayIndex = dates.findIndex(item =>item.code === curDay);//获取本周已到跟未到的日期分割索引
          if(dayIndex||dayIndex===0){
            newDays2.forEach((item,index) => {
              if(index<=dayIndex){
                item.isDisable = false;
              }else{
                item.isDisable = true;
              }
            })
          }
          weekDays = [...newDays1,...newDays2];
        }
        this.weekDays = weekDays;
      },
      dayChange(e, boo){//选择日期
        if (!boo) {
          this.curDay = e
          this.$emit('evtFromChart', 'echart', this.curVal, e)
        }
      },
      
      getGraphResult(revenue, actual) {
  
        var revBol = false
        var revenueData = []
        revenue.forEach(item => {
            if (item.cost > 0) {
              revBol = true
            }
  
            if (revBol) {
              revenueData.push(item)
            }
        })
  
        var actBol = false
        var actualData = []
        actual.forEach(item => {
            if (item.cost > 0) {
              actBol = true
            }
  
            if (actBol) {
              actualData.push(item)
            }
        })
  
        return {
          actualData: actualData,
          targetData: revenueData,
          targetCount: revenueData.length,
          actualCount: actualData.length,
          highestCount: actualData.length >= revenueData.length ? actualData.length : revenueData.length
        }
  
      },
  
      graphDatum(val, timezone) {
        if (!val || !timezone) {
          return
        }
        if (val.venueId) {
            let final = []
            var getTimeOfTimezone = Utils.getTimeOfTimezone(new Date(), timezone)
            getTimeOfTimezone = getTimeOfTimezone.replace(':', '')
            getTimeOfTimezone = parseInt(getTimeOfTimezone)
  
            var graphTime = Utils.dateTimeGeneratorWithDay(new Date(), timezone)
            var getCurrentDay = new Date(graphTime).getDay() != 0 ? new Date(graphTime).getDay() : 7
            if (this.curVal === "revenue") {
  
              let all_exist_datum_target = []
              if (val.revenueTargetPOJOList_today) {
                let revenueT = val.revenueTargetPOJOList_today
                // revenueData = revenueT
                var labelHours = []
  
                revenueT.forEach(item => {
                  if (item.isOpen) {
                    all_exist_datum_target.push(item.cost)
                    labelHours.push(item.labelHours)
                  }
                })
                this.lineOptions.xAxis[0].data = labelHours
              } 
  
              final.push({
                name: 'Target',
                type: 'line',
                data: all_exist_datum_target,
                smooth: true,
                showSymbol: false
              })
  
              let all_exist_datum = []
              if (val.actualHoursCostPOJOList) {
                let actualR = val.actualHoursCostPOJOList
                var actualRevenueToday = val.actualRevenue_today
                // actualData = actualR
  
                var firstRow = actualR[0].labelHours.replace(':', '')
                firstRow = parseInt(firstRow)
                
                actualR = actualR.map((n) => {
                  var labelHoursTime = n.labelHours.replace(':', '')
                  labelHoursTime = parseInt(labelHoursTime)
                  if (firstRow > labelHoursTime) {
                    n.labelHoursInt = labelHoursTime + 2400
                  } else {
                    n.labelHoursInt = labelHoursTime
                  }
  
                  return n
                })
                
                
                actualR = actualR.filter(n => n.isOpen)
                actualR.forEach(item => {
                  
                  // if (this.isPastMidnight) {
                  //   labelHoursTime += 2400
                  // }
                  
                  // if (!this.isPastMidnight) {
                  //   if (labelHoursTime >= 2345) {
                  //     this.isPastMidnight = true
                  //   }
                  // }
                  
                  if (this.currentDay === getCurrentDay && this.isThisWeek) {
                    if (getTimeOfTimezone >= item.labelHoursInt) {
                      var val = item.cost ? item.cost : 0
                      all_exist_datum.push(val)
                      // console.log(`${item.cost} ${item.labelHoursInt}`)
                      this.$emit('actual-revenue', actualRevenueToday, true)
                    }
                  } else {
                    all_exist_datum.push(item.cost)
                  }
  
                  // if (item.isOpen) {
                    // all_exist_datum.push(item.cost) 
                  // }
                })
  
                if (this.currentDay == getCurrentDay && this.isThisWeek) {
  
                } else {
                  
                  this.$emit('actual-revenue', actualRevenueToday, false)
                }
              } 
  
              final.push({
                name: 'Actual',
                type: 'line',
                data: all_exist_datum,
                smooth: true,
                showSymbol: false,
              })
  
            } else if (this.curVal === "labour") {
              let all_exist_datum = []
              if (val.labourTargetPOJOList_today) {
                let revenueT = val.labourTargetPOJOList_today
                var labelHours = []
                revenueT.forEach(item => {
                    if (item.isOpen) {
                      all_exist_datum.push(item.cost)
                      labelHours.push(item.labelHours)
                    }
                })
                this.lineOptions.xAxis[0].data = labelHours
                // console.log(this.lineOptions)
  
              } 
              
              final.push({
                name: 'Target',
                type: 'line',
                data: all_exist_datum,
                smooth: true,
                showSymbol: false
              })
              
              all_exist_datum = []
              if (val.actualHoursCostPOJOList) {
                let actualR = val.actualHoursCostPOJOList
                actualR = actualR.filter(n => n.isOpen)
                actualR.forEach(item => {
                  var labelHoursTime = item.labelHours.replace(':', '')
                  labelHoursTime = parseInt(labelHoursTime) - 15
                  
                  if (this.currentDay == getCurrentDay && this.isThisWeek) {
                    if (getTimeOfTimezone >= labelHoursTime) {
                      var val = item.cost ? item.cost : 0
                      all_exist_datum.push(val)
                      // this.$emit('actual-revenue', val)
                    }
                  } else {
                    all_exist_datum.push(item.cost)
                  }
                })
                
              } 
              final.push({
                name: 'Actual',
                type: 'line',
                data: all_exist_datum,
                smooth: true,
                showSymbol: false,
              })
            } 
            this.lineOptions.series = final
            this.$nextTick(() => {
              this.$refs.lineChart.resize();
            })
          }
      }
  
    },
    watch: {
      
      timeZone(val) {
  
        var dt = Utils.dateTimeGeneratorWithDay(new Date(), val)
        dt = new Date(dt).getDay()
        this.graphDatum(this.datum, val)
      },
      datum: {
        deep: true,
        handler: function (val) {
          if (this.timeZone) {
            this.graphDatum(val, this.timeZone)
          }
        }
      },
      dailyTrendDay: {
        deep: true,
        handler: function (val) {
          if (val)
            this.curDay = val
        }
      },
  
    }
  }
  </script>
  
  <style lang="scss" src="@/assets/css/echart.scss" scoped></style>


// WEBPACK FOOTER //
// src/components/dashboard/component/chart/revenueChart.vue